module.exports = __webpack_public_path__ + "static/5-8ecc894e1286207cd7a6fa6ecb811bb1.jpg";